import vue from 'vue'

export default {
    actions: {
        async getCallFilesByCallID(ctx, call_id) {
            if (!call_id) return
            const request = await vue.prototype.$http.get('/api/calls/' + call_id + '/files')

            ctx.commit('updateCallFiles', request.data.Data)
        },
        async addCallFile(ctx, payload) {
            if (!payload) return


            let fd = new FormData()
            for (let prop in payload) {
                if (payload.hasOwnProperty(prop) && payload[prop]) {
                    fd.append(prop, payload[prop])
                }
            }

            vue.prototype.$http.post('/api/calls/files', fd)
                .then(response => {
                    if (response.data.Success) {
                        vue.prototype.$message.success(response.data.Message)
                        ctx.commit('addCallFile', response.data.Data)
                    }
                    else {
                        throw new Error(response.data.Message)
                    }
                })
                .catch(reason => {
                    debugger
                })
        },
        async deleteCallFile(ctx, payload) {
            if (!payload) return

            const { file, index } = payload
            vue.prototype.$http.delete('/api/calls/files/' + file.call_file_id)
                .then(response => {
                    if (response.data.Success) {
                        vue.prototype.$message.success(response.data.Message)

                        if (index !== null || index !== undefined)
                            ctx.commit('deleteCallFile', index)
                    }
                    else {
                        throw new Error(response.data.Message)
                    }
                })
                .catch(reason => {
                    const title = reason.response.status ?? reason.response.data.Message
                    vue.prototype.$message.error(`Ошибка, файл не получен: ${title}`);
                })
        },
        async downloadCallFileByID(ctx, call) {
            if (!call) return

            vue.prototype.$http.get(`/api/calls/files/${call.call_file_id}/file`, { responseType: 'blob' })
                .then(response => {
                    const href = URL.createObjectURL(response.data)
                    const link = document.createElement('a')
                    link.href = href
                    link.setAttribute('download', call.file_name)
                    link.click()

                    URL.revokeObjectURL(href)
                })
                .catch(reason => {
                    const title = reason.response.status ?? reason.response.data.Message
                    this.$message.error(`Ошибка, файл не получен: ${title}`);
                })
        },
    },
    mutations: {
        updateCallFiles(state, callFiles) {
            state.callFiles = callFiles
        },
        addCallFile(state, callFile) {
            state.callFiles.unshift(callFile)
        },
        deleteCallFile(state, index) {
            state.callFiles.splice(index, 1)
        },
    },
    state: {
        callFiles: [],
    },
    getters: {
        getCallFiles(state) {
            return state.callFiles
        },
    },
}